
import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloCommande,cleanAloCommande } from '@/models/alo/AloCommande'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { AloPanier } from '@/models/alo/AloPanier'
import { AlsCommande } from '@/models/als/AlsCommande'

function parseCommandeData(data:string) {
  const resp =  JSON.parse(data) as AlrContainer<AloCommande>  
  if(resp.resultCode == ApiResultCode.Ok){
    const cmd = resp.data as AloCommande    
    cmd.panier = cmd.panJson?new AloPanier(JSON.parse(cmd.panJson)):new AloPanier()
  }    
  return resp
}

function parseCommandesData(data:string) {
  const resp =  JSON.parse(data) as AlrContainer<Array<AloCommande>>    
  if(resp.resultCode == ApiResultCode.Ok) {
    const cmds = resp.data as Array<AloCommande>        
    cmds.forEach(cmd =>  cmd.panier = cmd.panJson?new AloPanier(JSON.parse(cmd.panJson)):new AloPanier())   
  }    
  return resp
}

export default {
  getAllCommande(): AxiosPromise<AlrContainer<Array<AloCommande>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Panier`, 
      method: 'GET',
      transformResponse: [parseCommandesData]
    })
  },  
  getFilterCommande(cmdFilter: AlsCommande): AxiosPromise<AlrContainer<Array<AloCommande>>> {    
    if(cmdFilter.histo){
      return apiHelpers.apiCall({ 
        url: `/webapi/Panier/history`,               
        method: 'GET',
        transformResponse:  [parseCommandesData]
      })
    }
    else return apiHelpers.apiCall({ 
      url: `/webapi/Panier/filter`,       
      data:cmdFilter,
      method: 'POST',
      transformResponse:  [parseCommandesData]
    })
  },
  getCommande(id:number):AxiosPromise<AlrContainer<AloCommande>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Panier/${id}`, 
      method: 'GET',
      transformResponse: [parseCommandeData]
    })
  },
  saveCommande(commande:AloCommande):AxiosPromise<AlrContainer<AloCommande>> {
    cleanAloCommande(commande)
    if(commande.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Panier/${commande.id}`, 
        method: 'PUT',
        data: commande,
        transformResponse: [parseCommandeData]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Panier`, 
        method: 'POST',
        data: commande,
        transformResponse: [parseCommandeData]
      })    
    }
  },
  deleteCommande(id:number):AxiosPromise<AlrContainer<AloCommande>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Panier/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCommande>
      }]
    })
  }
}
 